// service/attendance.simple.js
import { db } from "../firebase-config";
import {
  doc,
  setDoc,
  serverTimestamp,
  collection,
  getDocs,
  getDoc,
  collectionGroup,
  query,
  where,
  documentId,
} from "firebase/firestore";

/** Write one student's mark */
export async function setAttendanceSimple({
  trainerId,
  batchId,
  moduleId,
  studentId,
  status,
}) {
  if (!trainerId || !batchId || !moduleId || !studentId) {
    throw new Error("setAttendanceSimple: missing ids");
  }
  const ref = doc(
    db,
    `users/${trainerId}/attendance/${String(batchId)}/modules/${String(
      moduleId
    )}/students/${String(studentId)}`
  );
  await setDoc(
    ref,
    { status, updatedAt: serverTimestamp(), index: studentId },
    { merge: true }
  );
}

/** Read all marks for a module (returns { [studentId]: {status, updatedAt} }) */
export async function getAttendanceByModuleSimple({
  trainerId,
  batchId,
  moduleId,
}) {
  if (!trainerId || !batchId || !moduleId) return {};
  const colRef = collection(
    db,
    `users/${trainerId}/attendance/${String(batchId)}/modules/${String(
      moduleId
    )}/students`
  );
  const snap = await getDocs(colRef);
  const out = {};
  snap.forEach((d) => {
    out[d.id] = d.data();
  });
  return out;
}

/**
 * Student view: read ALL my marks across trainers/batches/modules
 * Optional filter: trainerIds (array). If empty/omitted, returns all.
 *
 * Output rows your hook expects:
 *   { trainerId, batchId, moduleId, attendanceStatus, updatedAt, updatedAtSeconds }
 */
// service/attendance.simple.js
// Buggy Version
// export async function getMyAttendance(uid, trainerIds = [], { debug = false } = {}) {
//     if (!uid) return [];
//   console.log(",jhsdgfkzshcbzxjhfawrvqwnrzkxycgMXfvbaskjf");

//     const q = query(collectionGroup(db, "students"), where(documentId(), "==", uid));
//     console.log(",hguyfjhvtf76fjhbjg87tuyvjyr56dhgvjv");

//     const snap = await getDocs(q);

//     const rows = [];
//     console.log("[ATT] getMyAttendance", { uid, trainerIds });

//     snap.forEach((docSnap) => {
//       const data = docSnap.data() || {};

//       const studentsCol   = docSnap.ref.parent;   // .../students
//       const moduleDoc     = studentsCol.parent;   // .../modules/{moduleId}
//       const modulesCol    = moduleDoc.parent;     // .../modules
//       const attendanceDoc = modulesCol.parent;    // .../attendance/{batchId}
//       const attendanceCol = attendanceDoc.parent; // .../attendance
//       const userDoc       = attendanceCol.parent; // users/{trainerId}

//       const trainerId = userDoc.id;
//       const batchId   = attendanceDoc.id;
//       const moduleId  = moduleDoc.id;

//       if (Array.isArray(trainerIds) && trainerIds.length > 0 && !trainerIds.includes(trainerId)) {
//         console.log("skip (trainer filter)", { trainerId, batchId, moduleId, data });
//         return;
//       }

//       const row = {
//         trainerId,
//         batchId,
//         moduleId,
//         attendanceStatus:
//           data.status === "present" || data.status === "absent" ? data.status : "not_marked",
//         updatedAt: data.updatedAt || null,
//         updatedAtSeconds: data.updatedAt?.seconds ?? 0,
//       };
//       console.log("row", { path: docSnap.ref.path, ...row });

//       rows.push(row);
//     });

//       console.table(rows);
//       // console.groupEnd();

//     return rows;
//   }

// Working Version 1: Full Collection Scanned
// export async function getMyAttendance(
//   uid,
//   trainerIds = [],
//   { debug = false } = {},
//   batchId
// ) {
//   if (!uid) {
//     console.warn("⚠️ getMyAttendance called without uid");
//     return [];
//   }

//   console.log("➡️ Entered getMyAttendance with uid:", uid, "type:", typeof uid);

//   let snap;
//   try {
//     // ❌ removed where(documentId()) because it breaks collectionGroup
//     snap = await getDocs(collectionGroup(db, "students"));
//     if (debug) console.log("✅ getDocs resolved, total docs:", snap.size);
//   } catch (err) {
//     console.error("❌ Error running getDocs in getMyAttendance:", err);
//     return [];
//   }

//   const rows = [];
//   try {
//     snap.forEach((docSnap) => {
//       // keep only this student's docs
//       if (docSnap.id !== String(uid)) return;

//       const data = docSnap.data() || {};

//       const studentsCol = docSnap.ref.parent; // .../students
//       const moduleDoc = studentsCol.parent; // .../modules/{moduleId}
//       const modulesCol = moduleDoc.parent; // .../modules
//       const attendanceDoc = modulesCol.parent; // .../attendance/{batchId}
//       const attendanceCol = attendanceDoc.parent; // .../attendance
//       const userDoc = attendanceCol.parent; // users/{trainerId}

//       const trainerId = userDoc.id;
//       const batchId = attendanceDoc.id;
//       const moduleId = moduleDoc.id;

//       // Optional trainer filter
//       if (
//         Array.isArray(trainerIds) &&
//         trainerIds.length > 0 &&
//         !trainerIds.includes(trainerId)
//       ) {
//         if (debug) {
//           console.log("⏭️ Skipped due to trainer filter:", {
//             trainerId,
//             batchId,
//             moduleId,
//           });
//         }
//         return;
//       }

//       const row = {
//         trainerId,
//         batchId,
//         moduleId,
//         attendanceStatus:
//           data.status === "present" || data.status === "absent"
//             ? data.status
//             : "not_marked",
//         updatedAt: data.updatedAt || null,
//         updatedAtSeconds: data.updatedAt?.seconds ?? 0,
//       };

//       if (debug) {
//         console.log("📄 Row parsed:", { path: docSnap.ref.path, ...row });
//       }

//       rows.push(row);
//     });
//   } catch (err) {
//     console.error("❌ Error parsing snapshots in getMyAttendance:", err);
//     return [];
//   }

//   if (debug) {
//     console.table(rows);
//   }

//   return rows;
// }

// import {
//   collectionGroup,
//   doc,
//   getDocs,
//   query,
//   where,
// } from "firebase/firestore";
// import { db } from "./firebase"; // adjust your import

export async function getMyAttendance(
  uid,
  trainerIds = [],
  { debug = false } = {},
  batchId // renamed from targetBatchId
) {
  if (!uid) {
    console.warn("⚠️ getMyAttendance called without uid");
    return [];
  }
  if (!batchId) {
    console.warn("⚠️ getMyAttendance called without batchId");
    return [];
  }

  if (debug)
    console.log("➡️ Fetching attendance for uid:", uid, "batchId:", batchId);

  const rows = [];

  try {
    // 1️⃣ Collection group query for all students with uid
    const studentsQuery = query(
      collectionGroup(db, "students")
      // Removed documentId filter to avoid FirebaseError
    );

    const studentSnaps = await getDocs(studentsQuery);

    if (debug) console.log("✅ Student docs fetched:", studentSnaps.size);

    for (const studentDocSnap of studentSnaps.docs) {
      if (studentDocSnap.id !== String(uid)) continue; // filter by uid

      const data = studentDocSnap.data() || {};

      const moduleDoc = studentDocSnap.ref.parent.parent; // modules/{moduleId}
      const moduleId = moduleDoc.id;

      const attendanceDoc = moduleDoc.parent.parent; // attendance/{batchId}
      const currentBatchId = attendanceDoc.id;

      if (currentBatchId !== batchId) continue; // filter by batchId

      const trainerDoc = attendanceDoc.parent.parent; // users/{trainerId}
      const trainerId = trainerDoc.id;

      // Optional trainer filter
      if (
        Array.isArray(trainerIds) &&
        trainerIds.length > 0 &&
        !trainerIds.includes(trainerId)
      ) {
        if (debug) console.log("⏭️ Skipped trainerId:", trainerId);
        continue;
      }

      rows.push({
        trainerId,
        batchId: currentBatchId,
        moduleId,
        attendanceStatus:
          data.status === "present" || data.status === "absent"
            ? data.status
            : "not_marked",
        updatedAt: data.updatedAt || null,
        updatedAtSeconds: data.updatedAt?.seconds ?? 0,
      });
    }
  } catch (err) {
    console.error("❌ Error fetching attendance:", err);
    return [];
  }

  if (debug) console.table(rows);
  return rows;
}
